// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   LocalShipping as BatchIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   Science as ScienceIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const ProductionBatchesPage = () => {
//   const navigate = useNavigate();
//   const [batches, setBatches] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     tank: "",
//     quality_range: ""
//   });

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openSessionsDialog, setOpenSessionsDialog] = useState(false);
//   const [selectedBatch, setSelectedBatch] = useState(null);

//   // Form Data
//   const [batchForm, setBatchForm] = useState({
//     batch_code: "",
//     tank: "",
//     total_volume: "",
//     quality_score: ""
//   });

//   const [milkingSessionForm, setMilkingSessionForm] = useState({
//     session_id: ""
//   });

//   const [availableSessions, setAvailableSessions] = useState([]);

//   const API_URL = "https://dairy.server.statify.co.ke/api/production-batches";

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 150, label: 'Batch Code', dataKey: 'batch_code' },
//     { width: 120, label: 'Tank', dataKey: 'tank' },
//     { width: 120, label: 'Total Volume (L)', dataKey: 'total_volume' },
//     { width: 120, label: 'Quality Score', dataKey: 'quality_score' },
//     { width: 150, label: 'Created Date', dataKey: 'created_at' },
//     { width: 100, label: 'Sessions', dataKey: 'session_count' },
//     { width: 120, label: 'Status', dataKey: 'status' },
//     { width: 150, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Quality Ranges
//   const qualityRanges = [
//     { label: "Excellent (90-100)", min: 90, max: 100 },
//     { label: "Good (75-89)", min: 75, max: 89 },
//     { label: "Fair (60-74)", min: 60, max: 74 },
//     { label: "Poor (0-59)", min: 0, max: 59 }
//   ];

//   // Fetch Production Batches
//   const fetchBatches = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
      
//       if (Array.isArray(data)) {
//         // Transform data to include session count and status
//         const transformedBatches = data.map(batch => ({
//           ...batch,
//           session_count: batch.milking_sessions ? batch.milking_sessions.length : 0,
//           status: batch.quality_score >= 90 ? "Excellent" : 
//                  batch.quality_score >= 75 ? "Good" :
//                  batch.quality_score >= 60 ? "Fair" : "Poor",
//           created_at: new Date(batch.created_at).toLocaleDateString()
//         }));
//         setBatches(transformedBatches);
//       } else {
//         setBatches([]);
//       }
//     } catch (err) {
//       console.error('Error fetching production batches:', err);
//       swal("Error", "Failed to fetch production batches", "error");
//       setBatches([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch Available Milking Sessions
//   const fetchAvailableSessions = async () => {
//     try {
//       const res = await fetch("https://dairy.server.statify.co.ke/api/milking-sessions");
//       const data = await res.json();
//       if (Array.isArray(data)) {
//         setAvailableSessions(data);
//       }
//     } catch (err) {
//       console.error('Error fetching milking sessions:', err);
//     }
//   };

//   useEffect(() => {
//     fetchBatches();
//     fetchAvailableSessions();
//   }, []);

//   // Filter batches based on search and filters
//   useEffect(() => {
//     if (!Array.isArray(batches)) {
//       setFilteredBatches([]);
//       return;
//     }
    
//     let results = batches;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(batch =>
//         (batch.batch_code?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (batch.tank?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply tank filter
//     if (filters.tank) {
//       results = results.filter(batch => 
//         batch.tank?.toLowerCase() === filters.tank.toLowerCase()
//       );
//     }

//     // Apply quality filter
//     if (filters.quality_range) {
//       const range = qualityRanges.find(r => r.label === filters.quality_range);
//       if (range) {
//         results = results.filter(batch => 
//           batch.quality_score >= range.min && batch.quality_score <= range.max
//         );
//       }
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredBatches(results);
//   }, [batches, searchTerm, filters, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       tank: "",
//       quality_range: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setBatchForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setBatchForm({
//       batch_code: "",
//       tank: "",
//       total_volume: "",
//       quality_score: ""
//     });
//   };

//   // Create Batch
//   const handleCreateBatch = async () => {
//     // Validation
//     if (!batchForm.batch_code || !batchForm.total_volume) {
//       swal("Error", "Batch code and total volume are required", "error");
//       return;
//     }

//     if (batchForm.total_volume <= 0) {
//       swal("Error", "Total volume must be positive", "error");
//       return;
//     }

//     if (batchForm.quality_score && (batchForm.quality_score < 0 || batchForm.quality_score > 100)) {
//       swal("Error", "Quality score must be between 0 and 100", "error");
//       return;
//     }

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(batchForm),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Production batch created successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         fetchBatches();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Update Batch
//   const handleUpdateBatch = async () => {
//     if (!selectedBatch) return;

//     try {
//       const res = await fetch(`${API_URL}/${selectedBatch.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(batchForm),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Production batch updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedBatch(null);
//         resetForm();
//         fetchBatches();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (batchId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the production batch!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${batchId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchBatches();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // Add Milking Session to Batch
//   const handleAddSession = async () => {
//     if (!selectedBatch || !milkingSessionForm.session_id) {
//       swal("Error", "Please select a milking session", "error");
//       return;
//     }

//     try {
//       const res = await fetch(`${API_URL}/${selectedBatch.id}/milking-sessions/${milkingSessionForm.session_id}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Milking session added to batch successfully!", "success");
//         setMilkingSessionForm({ session_id: "" });
//         fetchBatches();
//         // Refresh the selected batch data
//         const updatedBatch = batches.find(b => b.id === selectedBatch.id);
//         if (updatedBatch) setSelectedBatch(updatedBatch);
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Remove Milking Session from Batch
//   const handleRemoveSession = async (sessionId) => {
//     if (!selectedBatch) return;

//     const confirm = await swal({
//       title: "Remove Session?",
//       text: "This will remove the milking session from the batch",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${selectedBatch.id}/milking-sessions/${sessionId}`, {
//           method: "DELETE",
//         });

//         const data = await res.json();
//         if (res.ok) {
//           swal("Success", "Milking session removed from batch!", "success");
//           fetchBatches();
//           // Refresh the selected batch data
//           const updatedBatch = batches.find(b => b.id === selectedBatch.id);
//           if (updatedBatch) setSelectedBatch(updatedBatch);
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // Open Edit Dialog
//   const handleEdit = (batch) => {
//     setSelectedBatch(batch);
//     setBatchForm({
//       batch_code: batch.batch_code,
//       tank: batch.tank || "",
//       total_volume: batch.total_volume,
//       quality_score: batch.quality_score || ""
//     });
//     setOpenEditDialog(true);
//   };

//   // Open Sessions Dialog
//   const handleManageSessions = (batch) => {
//     setSelectedBatch(batch);
//     setOpenSessionsDialog(true);
//   };

//   // View Batch Details - Redirect to detail page
//   const handleViewDetails = (batch) => {
//     navigate(`/production-batches/${batch.id}`);
//   };

//   // Get Quality Color
//   const getQualityColor = (score) => {
//     if (score >= 90) return 'success';
//     if (score >= 75) return 'info';
//     if (score >= 60) return 'warning';
//     return 'error';
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'primary.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, batch) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography 
//           variant="body2" 
//           fontWeight="bold" 
//           noWrap
//           onClick={() => handleViewDetails(batch)}
//           sx={{ 
//             cursor: 'pointer',
//             color: 'primary.main',
//             '&:hover': {
//               textDecoration: 'underline',
//               color: 'primary.dark'
//             }
//           }}
//         >
//           {batch.batch_code}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {batch.tank || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {batch.total_volume} L
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={batch.quality_score ? `${batch.quality_score}%` : 'N/A'} 
//           size="small"
//           color={batch.quality_score ? getQualityColor(batch.quality_score) : 'default'}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {batch.created_at}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={batch.session_count} 
//           size="small"
//           variant="outlined"
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={batch.status} 
//           size="small"
//           color={getQualityColor(batch.quality_score || 0)}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleManageSessions(batch)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(batch)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(batch.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'primary.dark' }}>
//         <Toolbar>
//           <BatchIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Production Batches
//           </Typography>
//           <Chip 
//             label={`${batches.length} Batches`} 
//             color="secondary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ borderRadius: 2, backgroundColor: 'success.main' }}
//           >
//             New Batch
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'primary.light' }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search batches by code, tank..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="primary"
//                   >
//                     Filters
//                   </Button>
//                   <Button onClick={resetFilters} variant="outlined" size="small" color="primary">
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Tank"
//                       value={filters.tank}
//                       onChange={(e) => handleFilterChange('tank', e.target.value)}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Quality Range</InputLabel>
//                       <Select
//                         value={filters.quality_range}
//                         onChange={(e) => handleFilterChange('quality_range', e.target.value)}
//                         label="Quality Range"
//                       >
//                         <MenuItem value="">All Qualities</MenuItem>
//                         {qualityRanges.map(range => (
//                           <MenuItem key={range.label} value={range.label}>{range.label}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
            
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="primary" />
//               </Box>
//             ) : filteredBatches.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'primary.light' }}>
//                 <CardContent>
//                   <ScienceIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
//                   <Typography variant="h5" color="primary.main" gutterBottom>
//                     No production batches found
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     Create your first production batch to start tracking milk production quality
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="primary" 
//                     onClick={() => setOpenCreateDialog(true)} 
//                     size="large"
//                   >
//                     Create First Batch
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'primary.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredBatches}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Batch Dialog */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => setOpenCreateDialog(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <AddIcon sx={{ mr: 1 }} />
//             Create New Production Batch
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={2} sx={{ mt: 1 }}>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Batch Code *"
//                 value={batchForm.batch_code}
//                 onChange={(e) => handleFormChange('batch_code', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Tank"
//                 value={batchForm.tank}
//                 onChange={(e) => handleFormChange('tank', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Total Volume (L) *"
//                 type="number"
//                 value={batchForm.total_volume}
//                 onChange={(e) => handleFormChange('total_volume', parseFloat(e.target.value))}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Quality Score (%)"
//                 type="number"
//                 inputProps={{ min: 0, max: 100 }}
//                 value={batchForm.quality_score}
//                 onChange={(e) => handleFormChange('quality_score', parseFloat(e.target.value))}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenCreateDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleCreateBatch} 
//             variant="contained" 
//             color="success"
//           >
//             Create Batch
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Batch Dialog */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <EditIcon sx={{ mr: 1 }} />
//             Edit Production Batch
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={2} sx={{ mt: 1 }}>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Batch Code *"
//                 value={batchForm.batch_code}
//                 onChange={(e) => handleFormChange('batch_code', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Tank"
//                 value={batchForm.tank}
//                 onChange={(e) => handleFormChange('tank', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Total Volume (L) *"
//                 type="number"
//                 value={batchForm.total_volume}
//                 onChange={(e) => handleFormChange('total_volume', parseFloat(e.target.value))}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Quality Score (%)"
//                 type="number"
//                 inputProps={{ min: 0, max: 100 }}
//                 value={batchForm.quality_score}
//                 onChange={(e) => handleFormChange('quality_score', parseFloat(e.target.value))}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleUpdateBatch} 
//             variant="contained" 
//             color="primary"
//           >
//             Update Batch
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Manage Sessions Dialog */}
//       <Dialog 
//         open={openSessionsDialog} 
//         onClose={() => setOpenSessionsDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <ViewIcon sx={{ mr: 1 }} />
//               Manage Milking Sessions - {selectedBatch?.batch_code}
//             </Box>
//             <IconButton onClick={() => setOpenSessionsDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedBatch && (
//             <Box>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom>
//                         Add Session to Batch
//                       </Typography>
//                       <FormControl fullWidth sx={{ mb: 2 }}>
//                         <InputLabel>Select Milking Session</InputLabel>
//                         <Select
//                           value={milkingSessionForm.session_id}
//                           onChange={(e) => setMilkingSessionForm({ session_id: e.target.value })}
//                           label="Select Milking Session"
//                         >
//                           {availableSessions.map(session => (
//                             <MenuItem key={session.id} value={session.id}>
//                               {session.session_code || `Session ${session.id}`}
//                             </MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                       <Button 
//                         fullWidth 
//                         variant="contained" 
//                         onClick={handleAddSession}
//                         disabled={!milkingSessionForm.session_id}
//                       >
//                         Add Session
//                       </Button>
//                     </CardContent>
//                   </Card>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom>
//                         Current Sessions ({selectedBatch.session_count})
//                       </Typography>
//                       <Box sx={{ maxHeight: 200, overflow: 'auto' }}>
//                         {selectedBatch.milking_sessions && selectedBatch.milking_sessions.length > 0 ? (
//                           selectedBatch.milking_sessions.map(session => (
//                             <Box 
//                               key={session.id} 
//                               sx={{ 
//                                 display: 'flex', 
//                                 justifyContent: 'space-between', 
//                                 alignItems: 'center',
//                                 py: 1,
//                                 borderBottom: '1px solid',
//                                 borderColor: 'divider'
//                               }}
//                             >
//                               <Typography variant="body2">
//                                 {session.session_code || `Session ${session.id}`}
//                               </Typography>
//                               <IconButton 
//                                 size="small" 
//                                 color="error"
//                                 onClick={() => handleRemoveSession(session.id)}
//                               >
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             </Box>
//                           ))
//                         ) : (
//                           <Typography variant="body2" color="textSecondary">
//                             No sessions associated
//                           </Typography>
//                         )}
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//       </Dialog>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="primary"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={() => setOpenCreateDialog(true)}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default ProductionBatchesPage;


import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  LocalShipping as BatchIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Science as ScienceIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const ProductionBatchesPage = () => {
  const navigate = useNavigate();
  const [batches, setBatches] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    tank: "",
    quality_range: ""
  });

  // Dialogs
  const [showFilters, setShowFilters] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openSessionsDialog, setOpenSessionsDialog] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);

  // Form Data
  const [batchForm, setBatchForm] = useState({
    batch_code: "",
    tank: "",
    total_volume: "",
    quality_score: ""
  });

  const [milkingSessionForm, setMilkingSessionForm] = useState({
    session_id: ""
  });

  const [availableSessions, setAvailableSessions] = useState([]);

  // Custom color theme
  const customColors = {
    primary: '#024A59', // Dark teal
    secondary: '#FFA916', // Orange
    lightTeal: '#e6f0f2',
    lightOrange: '#fff5e6'
  };

  const API_URL = "https://dairy.server.statify.co.ke/api/production-batches";

  // Table Columns for Virtualized Table
  const columns = [
    { width: 150, label: 'Batch Code', dataKey: 'batch_code' },
    { width: 120, label: 'Tank', dataKey: 'tank' },
    { width: 120, label: 'Total Volume (L)', dataKey: 'total_volume' },
    { width: 120, label: 'Quality Score', dataKey: 'quality_score' },
    { width: 150, label: 'Created Date', dataKey: 'created_at' },
    { width: 100, label: 'Sessions', dataKey: 'session_count' },
    { width: 120, label: 'Status', dataKey: 'status' },
    { width: 150, label: 'Actions', dataKey: 'actions' },
  ];

  // Quality Ranges
  const qualityRanges = [
    { label: "Excellent (90-100)", min: 90, max: 100 },
    { label: "Good (75-89)", min: 75, max: 89 },
    { label: "Fair (60-74)", min: 60, max: 74 },
    { label: "Poor (0-59)", min: 0, max: 59 }
  ];

  // Fetch Production Batches
  const fetchBatches = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      
      if (Array.isArray(data)) {
        // Transform data to include session count and status
        const transformedBatches = data.map(batch => ({
          ...batch,
          session_count: batch.milking_sessions ? batch.milking_sessions.length : 0,
          status: batch.quality_score >= 90 ? "Excellent" : 
                 batch.quality_score >= 75 ? "Good" :
                 batch.quality_score >= 60 ? "Fair" : "Poor",
          created_at: new Date(batch.created_at).toLocaleDateString()
        }));
        setBatches(transformedBatches);
      } else {
        setBatches([]);
      }
    } catch (err) {
      console.error('Error fetching production batches:', err);
      swal("Error", "Failed to fetch production batches", "error");
      setBatches([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Available Milking Sessions
  const fetchAvailableSessions = async () => {
    try {
      const res = await fetch("https://dairy.server.statify.co.ke/api/milking-sessions");
      const data = await res.json();
      if (Array.isArray(data)) {
        setAvailableSessions(data);
      }
    } catch (err) {
      console.error('Error fetching milking sessions:', err);
    }
  };

  useEffect(() => {
    fetchBatches();
    fetchAvailableSessions();
  }, []);

  // Filter batches based on search and filters
  useEffect(() => {
    if (!Array.isArray(batches)) {
      setFilteredBatches([]);
      return;
    }
    
    let results = batches;

    // Apply search term
    if (searchTerm) {
      results = results.filter(batch =>
        (batch.batch_code?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (batch.tank?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply tank filter
    if (filters.tank) {
      results = results.filter(batch => 
        batch.tank?.toLowerCase() === filters.tank.toLowerCase()
      );
    }

    // Apply quality filter
    if (filters.quality_range) {
      const range = qualityRanges.find(r => r.label === filters.quality_range);
      if (range) {
        results = results.filter(batch => 
          batch.quality_score >= range.min && batch.quality_score <= range.max
        );
      }
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredBatches(results);
  }, [batches, searchTerm, filters, sortConfig]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      tank: "",
      quality_range: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  };

  // Form Handlers
  const handleFormChange = (field, value) => {
    setBatchForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setBatchForm({
      batch_code: "",
      tank: "",
      total_volume: "",
      quality_score: ""
    });
  };

  // Create Batch
  const handleCreateBatch = async () => {
    // Validation
    if (!batchForm.batch_code || !batchForm.total_volume) {
      swal("Error", "Batch code and total volume are required", "error");
      return;
    }

    if (batchForm.total_volume <= 0) {
      swal("Error", "Total volume must be positive", "error");
      return;
    }

    if (batchForm.quality_score && (batchForm.quality_score < 0 || batchForm.quality_score > 100)) {
      swal("Error", "Quality score must be between 0 and 100", "error");
      return;
    }

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(batchForm),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Production batch created successfully!", "success");
        setOpenCreateDialog(false);
        resetForm();
        fetchBatches();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Update Batch
  const handleUpdateBatch = async () => {
    if (!selectedBatch) return;

    try {
      const res = await fetch(`${API_URL}/${selectedBatch.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(batchForm),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Production batch updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedBatch(null);
        resetForm();
        fetchBatches();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Delete Handler
  const handleDelete = async (batchId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the production batch!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${batchId}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchBatches();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // Add Milking Session to Batch
  const handleAddSession = async () => {
    if (!selectedBatch || !milkingSessionForm.session_id) {
      swal("Error", "Please select a milking session", "error");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/${selectedBatch.id}/milking-sessions/${milkingSessionForm.session_id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Milking session added to batch successfully!", "success");
        setMilkingSessionForm({ session_id: "" });
        fetchBatches();
        // Refresh the selected batch data
        const updatedBatch = batches.find(b => b.id === selectedBatch.id);
        if (updatedBatch) setSelectedBatch(updatedBatch);
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Remove Milking Session from Batch
  const handleRemoveSession = async (sessionId) => {
    if (!selectedBatch) return;

    const confirm = await swal({
      title: "Remove Session?",
      text: "This will remove the milking session from the batch",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${selectedBatch.id}/milking-sessions/${sessionId}`, {
          method: "DELETE",
        });

        const data = await res.json();
        if (res.ok) {
          swal("Success", "Milking session removed from batch!", "success");
          fetchBatches();
          // Refresh the selected batch data
          const updatedBatch = batches.find(b => b.id === selectedBatch.id);
          if (updatedBatch) setSelectedBatch(updatedBatch);
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // Open Edit Dialog
  const handleEdit = (batch) => {
    setSelectedBatch(batch);
    setBatchForm({
      batch_code: batch.batch_code,
      tank: batch.tank || "",
      total_volume: batch.total_volume,
      quality_score: batch.quality_score || ""
    });
    setOpenEditDialog(true);
  };

  // Open Sessions Dialog
  const handleManageSessions = (batch) => {
    setSelectedBatch(batch);
    setOpenSessionsDialog(true);
  };

  // View Batch Details - Redirect to detail page
  const handleViewDetails = (batch) => {
    navigate(`/production-batches/${batch.id}`);
  };

  // Get Quality Color
  const getQualityColor = (score) => {
    if (score >= 90) return 'success';
    if (score >= 75) return 'info';
    if (score >= 60) return 'warning';
    return 'error';
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: customColors.primary, 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, batch) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography 
          variant="body2" 
          fontWeight="bold" 
          noWrap
          onClick={() => handleViewDetails(batch)}
          sx={{ 
            cursor: 'pointer',
            color: customColors.primary,
            '&:hover': {
              textDecoration: 'underline',
              color: customColors.secondary
            }
          }}
        >
          {batch.batch_code}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {batch.tank || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {batch.total_volume} L
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={batch.quality_score ? `${batch.quality_score}%` : 'N/A'} 
          size="small"
          color={batch.quality_score ? getQualityColor(batch.quality_score) : 'default'}
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: batch.quality_score ? undefined : customColors.lightTeal
          }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {batch.created_at}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={batch.session_count} 
          size="small"
          variant="outlined"
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            borderColor: customColors.primary,
            color: customColors.primary
          }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={batch.status} 
          size="small"
          color={getQualityColor(batch.quality_score || 0)}
          sx={{ fontSize: '0.7rem', height: '24px' }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            onClick={() => handleManageSessions(batch)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: customColors.primary,
              '&:hover': {
                backgroundColor: customColors.lightOrange
              }
            }}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleEdit(batch)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: customColors.primary,
              '&:hover': {
                backgroundColor: customColors.lightOrange
              }
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleDelete(batch.id)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: '#d32f2f',
              '&:hover': {
                backgroundColor: '#ffebee'
              }
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: customColors.primary }}>
        <Toolbar>
          <BatchIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Production Batches
          </Typography>
          <Chip 
            label={`${batches.length} Batches`} 
            sx={{ 
              backgroundColor: customColors.secondary, 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={() => setOpenCreateDialog(true)}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: customColors.secondary,
              '&:hover': {
                backgroundColor: '#e69900'
              }
            }}
          >
            New Batch
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ 
          mb: 3, 
          borderRadius: 2, 
          border: 2, 
          borderColor: customColors.lightTeal,
          backgroundColor: customColors.lightTeal
        }}>
          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search batches by code, tank..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: customColors.primary, mr: 1 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? customColors.primary : 'transparent',
                      color: showFilters ? 'white' : customColors.primary,
                      borderColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: showFilters ? '#023a47' : customColors.lightOrange,
                        borderColor: customColors.primary
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: customColors.primary,
                      borderColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: customColors.lightOrange,
                        borderColor: customColors.primary
                      }
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Tank"
                      value={filters.tank}
                      onChange={(e) => handleFilterChange('tank', e.target.value)}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&:hover fieldset': {
                            borderColor: customColors.primary,
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: customColors.primary,
                          },
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Quality Range</InputLabel>
                      <Select
                        value={filters.quality_range}
                        onChange={(e) => handleFilterChange('quality_range', e.target.value)}
                        label="Quality Range"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                      >
                        <MenuItem value="">All Qualities</MenuItem>
                        {qualityRanges.map(range => (
                          <MenuItem key={range.label} value={range.label}>{range.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: customColors.primary }} />
              </Box>
            ) : filteredBatches.length === 0 ? (
              <Card sx={{ 
                textAlign: 'center', 
                p: 4, 
                border: 2, 
                borderColor: customColors.lightTeal,
                backgroundColor: 'white'
              }}>
                <CardContent>
                  <ScienceIcon sx={{ fontSize: 64, color: customColors.primary, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: customColors.primary, mb: 1 }}>
                    No production batches found
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    Create your first production batch to start tracking milk production quality
                  </Typography>
                  <Button 
                    variant="contained" 
                    onClick={() => setOpenCreateDialog(true)} 
                    size="large"
                    sx={{
                      backgroundColor: customColors.secondary,
                      '&:hover': {
                        backgroundColor: '#e69900'
                      }
                    }}
                  >
                    Create First Batch
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ 
                height: 600, 
                border: 1, 
                borderColor: customColors.lightTeal, 
                borderRadius: 1 
              }}>
                <TableVirtuoso
                  data={filteredBatches}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Create Batch Dialog */}
      <Dialog 
        open={openCreateDialog} 
        onClose={() => setOpenCreateDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: customColors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <AddIcon sx={{ mr: 1 }} />
            Create New Production Batch
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Batch Code *"
                value={batchForm.batch_code}
                onChange={(e) => handleFormChange('batch_code', e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Tank"
                value={batchForm.tank}
                onChange={(e) => handleFormChange('tank', e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Total Volume (L) *"
                type="number"
                value={batchForm.total_volume}
                onChange={(e) => handleFormChange('total_volume', parseFloat(e.target.value))}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Quality Score (%)"
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={batchForm.quality_score}
                onChange={(e) => handleFormChange('quality_score', parseFloat(e.target.value))}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenCreateDialog(false)}
            sx={{ color: customColors.primary }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleCreateBatch} 
            variant="contained"
            sx={{
              backgroundColor: customColors.secondary,
              '&:hover': {
                backgroundColor: '#e69900'
              }
            }}
          >
            Create Batch
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Batch Dialog */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => setOpenEditDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: customColors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <EditIcon sx={{ mr: 1 }} />
            Edit Production Batch
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Batch Code *"
                value={batchForm.batch_code}
                onChange={(e) => handleFormChange('batch_code', e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Tank"
                value={batchForm.tank}
                onChange={(e) => handleFormChange('tank', e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Total Volume (L) *"
                type="number"
                value={batchForm.total_volume}
                onChange={(e) => handleFormChange('total_volume', parseFloat(e.target.value))}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Quality Score (%)"
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={batchForm.quality_score}
                onChange={(e) => handleFormChange('quality_score', parseFloat(e.target.value))}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenEditDialog(false)}
            sx={{ color: customColors.primary }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdateBatch} 
            variant="contained"
            sx={{
              backgroundColor: customColors.primary,
              '&:hover': {
                backgroundColor: '#023a47'
              }
            }}
          >
            Update Batch
          </Button>
        </DialogActions>
      </Dialog>

      {/* Manage Sessions Dialog */}
      <Dialog 
        open={openSessionsDialog} 
        onClose={() => setOpenSessionsDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: customColors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ViewIcon sx={{ mr: 1 }} />
              Manage Milking Sessions - {selectedBatch?.batch_code}
            </Box>
            <IconButton 
              onClick={() => setOpenSessionsDialog(false)}
              sx={{ color: 'white' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedBatch && (
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card 
                    variant="outlined"
                    sx={{ borderColor: customColors.lightTeal }}
                  >
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                        Add Session to Batch
                      </Typography>
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Select Milking Session</InputLabel>
                        <Select
                          value={milkingSessionForm.session_id}
                          onChange={(e) => setMilkingSessionForm({ session_id: e.target.value })}
                          label="Select Milking Session"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '&:hover fieldset': {
                                borderColor: customColors.primary,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: customColors.primary,
                              },
                            }
                          }}
                        >
                          {availableSessions.map(session => (
                            <MenuItem key={session.id} value={session.id}>
                              {session.session_code || `Session ${session.id}`}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Button 
                        fullWidth 
                        variant="contained" 
                        onClick={handleAddSession}
                        disabled={!milkingSessionForm.session_id}
                        sx={{
                          backgroundColor: customColors.secondary,
                          '&:hover': {
                            backgroundColor: '#e69900'
                          }
                        }}
                      >
                        Add Session
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Card 
                    variant="outlined"
                    sx={{ borderColor: customColors.lightTeal }}
                  >
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                        Current Sessions ({selectedBatch.session_count})
                      </Typography>
                      <Box sx={{ maxHeight: 200, overflow: 'auto' }}>
                        {selectedBatch.milking_sessions && selectedBatch.milking_sessions.length > 0 ? (
                          selectedBatch.milking_sessions.map(session => (
                            <Box 
                              key={session.id} 
                              sx={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                py: 1,
                                borderBottom: '1px solid',
                                borderColor: 'divider'
                              }}
                            >
                              <Typography variant="body2">
                                {session.session_code || `Session ${session.id}`}
                              </Typography>
                              <IconButton 
                                size="small" 
                                sx={{
                                  color: '#d32f2f',
                                  '&:hover': {
                                    backgroundColor: '#ffebee'
                                  }
                                }}
                                onClick={() => handleRemoveSession(session.id)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          ))
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            No sessions associated
                          </Typography>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Add FAB for mobile */}
      <Fab
        aria-label="add"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: customColors.secondary,
          color: 'white',
          '&:hover': {
            backgroundColor: '#e69900'
          }
        }}
        onClick={() => setOpenCreateDialog(true)}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default ProductionBatchesPage;